var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "62px",
    viewBox: "0 0 46 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M570,907 L598,907 C600.209139,907 602,908.790861 602,911 L602,955 C602,957.209139 600.209139,959 598,959 L570,959 C567.790861,959 566,957.209139 566,955 L566,911 C566,908.790861 567.790861,907 570,907 Z M576,932 C573.790861,932 572,933.790861 572,936 L572,949 C572,951.209139 573.790861,953 576,953 L592,953 C594.209139,953 596,951.209139 596,949 L596,936 C596,933.790861 594.209139,932 592,932 L576,932 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.0%",
    y: "-17.3%",
    width: "144.4%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.277258832 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jeremy",
    transform: "translate(-562.000000, -903.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(584.000000, 933.000000) rotate(-180.000000) translate(-584.000000, -933.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EFEFEF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSimple);
export default __webpack_public_path__ + "static/media/button-simple.4ceaf781d0cfb3d65fd3b75a22d05fbf.svg";
export { ForwardRef as ReactComponent };